import { keepPreviousData, queryOptions } from '@tanstack/react-query';
import type { SessionClient } from '@portal/platform/http';
import { fetchComplianceConfig, fetchComplianceReport } from './api';
import type { ComplianceReportQuery } from './types';

/**
 * The monitor's queries. Not keyed on the org node: the default query scope resets them on a
 * node or view-mode switch (see `session-queries.ts`).
 */
export const complianceKeys = {
  all: ['compliance-monitor'] as const,
  reports: ['compliance-monitor', 'report'] as const,
  report: (query: ComplianceReportQuery) => ['compliance-monitor', 'report', query] as const,
  config: ['compliance-monitor', 'config'] as const,
};

// `client` is the session's transport, not an input to the answer.
/* eslint-disable @tanstack/query/exhaustive-deps */

export const complianceReportQueryOptions = (client: SessionClient, query: ComplianceReportQuery) =>
  queryOptions({
    queryKey: complianceKeys.report(query),
    queryFn: () => fetchComplianceReport(client, query),
    // The table keeps the previous page under its loading overlay instead of emptying.
    placeholderData: keepPreviousData,
  });

export const complianceConfigQueryOptions = (client: SessionClient) =>
  queryOptions({
    queryKey: complianceKeys.config,
    queryFn: () => fetchComplianceConfig(client),
  });

/* eslint-enable @tanstack/query/exhaustive-deps */
